const getSubscriptionsFromState = (state) => {
   return { exercise: true, course: true };

   const subData =
      state.appData.permissions?.subscriptionAndPurchases?.subscription;

   const subscriptions = { exercise: false, course: false };
   if (subData && new Date(subData.expiration) > Date.now()) {
      if (subData.includes.includes('exercise')) {
         subscriptions.exercise = true;
      }
      if (subData.includes.includes('course')) {
         subscriptions.course = true;
      }
   }

   return subscriptions;
};

export { getSubscriptionsFromState };
